import GlobalStorageService from "./GlobalStorage.service";
import CookieService from "./Cookie.service";
import LocalStorageService from "./LocalStorage.service";
// Models
import IQuiz from "models/Quiz";
// Utilities
import { decodeBase64 } from 'utilities/Utilities';

class StorageService {
  private static _iframe: boolean = false;
  private static _preview: boolean = false;
  private static _referrer: string | null = null;
  private static _slug: string = '';
  private static _quiz: IQuiz | null = null;

  public static getDataFromUrl() {
    const { pathname, search } = window.location;
    // Get slug|nonce from url
    // TODO:  list examples of URLs where nonce is considered as a slug
    const [ , urlSlug, urlNonce ] = pathname.split('/').filter(Boolean);
    const slug = pathname.includes('live-leaderboard') || pathname.includes('live-results') ? urlSlug : urlNonce || urlSlug;
    this._setSlug(slug);
    // Get params from url
    const params = new URLSearchParams(search);

    this._enableIframe(params.get('iframe'));
    this._enablePreview(params.get('preview'));
    this._enableReferrer(params.get('referrer'));

    const nonce = params.get('nonce');
    const qwid = params.get('qwid');

    if (this._preview) {
      // set data into local variable
      if (nonce) GlobalStorageService.setNonce(nonce);
      if (qwid) GlobalStorageService.setQwid(qwid);
    } else if (this._iframe) {
      // set data into window cookie
      if (nonce) CookieService.setNonce(slug, nonce);
      if (qwid) CookieService.setQwid(qwid);
    } else {
      // set data to local storage
      if (nonce) LocalStorageService.setNonce(slug, nonce);
      if (qwid) LocalStorageService.setQwid(qwid);
    }
  }

  public static getSlug(): string | null {
    return this._slug;
  }

  public static getQuiz(): IQuiz | null {
    return this._quiz;
  }

  // Set
  public static setQuiz(quizHash: string) {
    this._quiz = decodeBase64(quizHash);
  }

  public static setNonce(nonce: string) {
    if (this._preview) {
      GlobalStorageService.setNonce(nonce);
    } else if (this._iframe) {
      CookieService.setNonce(this._slug, nonce);
    } else {
      LocalStorageService.setNonce(this._slug, nonce);
    }
  }

  public static setQwid(qwid: string) {
    if (this._preview) {
      GlobalStorageService.setQwid(qwid);
    } else if (this._iframe) {
      CookieService.setQwid(qwid);
    } else {
      LocalStorageService.setQwid(qwid);
    }
  }

  // Get
  public static getNonce(): string | null {
    if (this._preview) {
      return GlobalStorageService.getNonce();
    } else if (this._iframe) {
      return CookieService.getNonce();
    } else {
      return LocalStorageService.getNonce(this._slug);
    }
  }

  public static getQwid(): string | null {
    if (this._preview) {
      return GlobalStorageService.getQwid();
    } else if (this._iframe) {
      return CookieService.getQwid();
    } else {
      return LocalStorageService.getQwid();
    }
  }

  public static getReferrer(): string | null {
    return this._referrer;
  }

  public static removeQwid() {
    if (this._preview) {
      GlobalStorageService.removeQwid();
    } else if (this._iframe) {
      CookieService.removeQwid();
    } else {
      LocalStorageService.removeQwid();
    }
  }

  // Clear
  public static clearStorage() {
    GlobalStorageService.clearStorage();
    CookieService.clearStorage(this._slug);
    LocalStorageService.clearStorage(this._slug);
  }

  private static _enableIframe(iframe: string | null) {
    if (iframe) this._iframe = true;
  }

  private static _enablePreview(preview: string | null) {
    if (preview) this._preview = true;
  }

  private static _enableReferrer(referrer: string | null) {
    if (referrer) {
      this._referrer = decodeURIComponent(referrer)
    } else {
      this._referrer = document.referrer;
    };
  }

  private static _setSlug(slug: string) {
    this._slug = slug;
  }
}

export default StorageService;
